import { render, staticRenderFns } from "./PaginatedTable.vue?vue&type=template&id=787d8554&"
import script from "./PaginatedTable.vue?vue&type=script&lang=js&"
export * from "./PaginatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports